import format from 'date-fns/format'
import { parseDate } from './dateTimeHelper'

export const formatStudyDuration = (startDate, graduationDate, dateFormat = 'MMM yyyy', dateRangeSymbol = '\u2013') => {
  // '\u2013' is equivalent to HTML '&ndash;' entity

  if (!startDate && !graduationDate) return null
  if (!startDate) return format(parseDate(graduationDate), dateFormat)
  if (!graduationDate) return format(parseDate(startDate), dateFormat)

  return `${format(parseDate(startDate), dateFormat)} ${dateRangeSymbol} ${format(parseDate(graduationDate), dateFormat)}`
}
